// import BackgroundLoader from '../background-loader';
import NotificationListener from '../../notifications/components/notification-listener';
import { Slide, ToastContainer } from 'react-toastify';
import Router from './router';
import SearchBar from '../search-bar';
import 'react-toastify/dist/ReactToastify.css';
import { Toaster } from 'sonner';
import NotificationSubscription from '../../notifications/components/notification-subscription';

function Layout(): JSX.Element {
  return (
    <>
      <Toaster
        position="top-right"
        toastOptions={
          {
            // style: {
            //   width: '300px',
            // }
          }
        }
      />
      <SearchBar />
      <Router />
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover
        theme="light"
        transition={Slide}
      />
      <NotificationSubscription />
      <NotificationListener />
    </>
  );
}

export default Layout;
